/**
 * cypAdhdNoteTagOptions.js
 *
 * Tag catalogue for StructuredNotesEditor when used on CYP ADHD proforma
 * notes boxes (CI, SSI symptom notes, Review and Synthesis, DD formulation,
 * PAD discussion capture).
 *
 * CYP notes are tagged by SOURCE — who said it — rather than by DSM
 * criterion:
 *   - The SSI symptom pages are already scoped one-symptom-per-page, so a
 *     DSM tag would restate the page the note is on.
 *   - What the clinician needs to preserve is attribution: whether an
 *     observation came from the parent/carer, the child themselves, or the
 *     school. That attribution survives into the LLM prompt inputs (see
 *     python-functions/firestore_fns/structured_notes_utils.py).
 *
 * Ids are namespaced `source_*` so they can never collide with autism's
 * DSM criterion ids (`criteriaTags` is a shared field on the note object).
 *
 * Taxonomy flagged for confirmation with Sai/Tom (ASMT-29); labels follow
 * the CYP wording rules (never a generic "Informant", never "Supervisor").
 */

/**
 * Is the Tag action offered on CYP notes boxes?
 *
 * FALSE since the 1 Sept design review (Tom, Sai, Eve): tagging adds steps
 * for the clinician and its utility is not yet clear, so the feature is
 * HIDDEN until the workflow is workshopped — not deleted. The catalogue, the
 * per-note `criteriaTags` field, and the backend readers that carry a tag's
 * source into the report prompts all stay in place, so flipping this back to
 * true restores the whole feature.
 *
 * Until then the agreed alternative is plain double quotation marks in the
 * note text to mark a quote. Suggested prompts stay in the UI (same review).
 *
 * Tags already recorded are kept and still render on their notes; only the
 * ability to add or change one is withdrawn.
 */
export const CYP_NOTE_TAGGING_ENABLED = false;

export const CYP_NOTE_TAG_OPTIONS = [
  { id: 'source_parent', label: 'Parent/carer' },
  { id: 'source_child', label: 'Child' },
  { id: 'source_school', label: 'School' },
];

/** Quick lookup: tag id → display label. */
export const CYP_NOTE_TAG_LABEL_BY_ID = Object.fromEntries(
  CYP_NOTE_TAG_OPTIONS.map((t) => [t.id, t.label]),
);
